import { Component, OnInit } from '@angular/core'
import { UserModel } from '../../../../models/user.model'
import { Subscription } from 'rxjs/Subscription'
import { MatTableDataSource } from '@angular/material'
import { AdminUsersService } from '../../services/admin-users.service'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-admin-user-list',
  templateUrl: './admin-user-list.component.html',
  styleUrls: ['./admin-user-list.component.scss'],
})
export class AdminUserListComponent implements OnInit {
  searchInput: string
  users: UserModel[]
  currentUser: UserModel
  onFilterChanged: Subscription
  onUserChanged: Subscription
  limit: number
  displayedColumns = ['name', 'email', 'status', 'origin', 'last_login']
  dataSource: any
  isLoading = false
  administrationId: number

  constructor(private adminUserService: AdminUsersService, private route: ActivatedRoute) {
    this.administrationId = this.route.snapshot.params['administrationId']
  }

  ngOnInit() {
    this.onFilterChanged = this.adminUserService.onFilterChanged
      .do(() => (this.isLoading = true))
      .switchMap(() => this.adminUserService.list(this.administrationId))
      .map(results => {
        this.users = results
        this.dataSource = new MatTableDataSource<UserModel>(this.users)
        this.adminUserService.onUsersChanged.next(results)
      })
      .do(() => (this.isLoading = false))
      .subscribe()

    this.onUserChanged = this.adminUserService.onUserChanged.subscribe(user => {
      if (user == undefined) {
        this.displayedColumns = ['name', 'email', 'status', 'origin', 'last_login']
      } else {
        this.displayedColumns = ['name', 'email']
      }
      this.currentUser = user
    })
  }

  ngOnDestroy() {
    this.onFilterChanged.unsubscribe()
    this.onUserChanged.unsubscribe()
  }

  /**
   *
   * @param {UserModel} user
   */
  readUser(user: UserModel) {
    this.adminUserService.setCurrentUser(user)
  }

  getServerData(event) {
    this.adminUserService.changeFilter(event)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/admin-users/admin-user-list/admin-user-list.component.ts